/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React, {useEffect, useState} from "react";
import {
    Box,
    Grid,
    Form,
    FormField,
    TextInput,
    TextArea,
    Header,
    Button,
    Layer
} from 'grommet'
import ProduceCard from "Components/ProduceCard";
import {getUser} from "API/API";



type Props = {
    User: any
}

const MyProduce: React.FC<Props> = (props) => {
    const [refresh, setRefresh] = useState<boolean>(false)
    const [loaded, setLoaded] = useState<boolean>(false)
    const [veggitUser, setVeggitUser] = useState<API.VeggitUser>()


    useEffect(() => {
        console.log("Not loaded")
        getUser(props.User.sub).then(res => {
            if (res.Produce == null) {
                res.Produce = []
            }
            setVeggitUser(res)
            setLoaded(true)
            setRefresh(false)
        })
    }, [refresh])

    const refreshFunc = () => {
        setRefresh(true)
    }

    return (
        <>
        {/*<Box*/}
        {/*    responsive={true}*/}
        {/*>*/}
            <Grid
                rows={'medium'}
                columns={'small'}
                gap={"xsmall"}
            >
                {loaded && veggitUser.Produce.map( (prod) =>  <ProduceCard refreshFunc={refreshFunc} {... prod}/>) }

            </Grid>
        {/*</Box>*/}




        </>
    )
}


export default MyProduce
